import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycaranddriverrental() {



  const cardData =
  {
    keyword: 'Monthly Car and Driver Rentals in Mumbai',
    heading: 'Aaryan Travels: Monthly Car and Driver Rentals in Mumbai',
    headingDescription: ' Aaryan Travels offers convenient Monthly Car and Driver Rentals in Mumbai for professionals, corporate executives, and families who require reliable long-term transportation. Whether you need a sedan for daily office travel, an SUV for business meetings, or a luxury car for high-profile mobility, our chauffeur-driven vehicles are available on fixed monthly contracts with transparent billing and flexible usage. With well-trained drivers, GPS-enabled vehicles, and 24/7 support, we ensure punctual and stress-free travel across major areas like Andheri, Bandra, Powai, Navi Mumbai, and South Mumbai. Aaryan Travels eliminates the hassle of daily bookings by delivering personalized monthly car rental services with a dedicated driver.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 facing the Arabian Sea, the Gateway of India is Mumbai’s most iconic monument. Tourists gather here to enjoy ferry rides to Elephanta Caves and admire the majestic arch structure. Street vendors, photographers, and bustling crowds make the surroundings lively. When illuminated at night, it becomes a picture-perfect sight. The Gateway of India is Mumbai’s grand symbol of pride and history."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km-long promenade curving along the coastline. People visit for sunset strolls, ocean breeze, and roadside chai. At night, the streetlights resemble a glowing necklace across the bay. Joggers, couples, and photographers frequent the spot daily. Marine Drive is Mumbai’s most relaxing seaside escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO World Heritage railway station built in 1887 in Victorian Gothic style. The stained-glass windows, domes, and intricate carvings make it look like a royal palace. Despite its historic charm, it remains one of India’s busiest transport hubs. The station glows beautifully under night lights. CST is Mumbai’s iconic blend of heritage and hustle."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beachfront known for street snacks like pav bhaji, bhel puri, and kulfi. Families enjoy camel rides and children play along the sandy shore. Bollywood celebrities often visit the nearby area, adding glamour. Sunsets here are vibrant and lively. Juhu Beach is Mumbai’s fun-filled coastline of flavors."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet connected by a narrow causeway. It appears to float on water during high tide. Devotees from all religions visit to seek blessings and listen to soulful qawwali music. Its white marble structure offers a serene contrast against the blue sea. Haji Ali is Mumbai’s sacred oasis of peace."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, feature rock-cut sculptures dedicated to Lord Shiva dating back to the 5th century. The Trimurti statue is the main highlight, showcasing Shiva in three forms. Visitors access the site via ferry from the Gateway of India. Surrounded by greenery and ancient art, it offers a mystical experience. Elephanta Caves are Mumbai’s historic treasure of spirituality."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited temples dedicated to Lord Ganesha. Devotees, including celebrities and politicians, queue up daily for darshan. The gold-plated dome and carved wooden doors add grandeur. Tuesdays are especially crowded for special aarti. Siddhivinayak is Mumbai’s divine center of belief and blessings."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern architectural marvel connecting South Mumbai to the suburbs. Driving across the bridge offers stunning skyline and ocean views. At night, the illuminated cables create a futuristic visual. It significantly reduces travel time while showcasing urban sophistication. The Sea Link is Mumbai’s engineering signature."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most vibrant street market known for affordable fashion, jewelry, antiques, and souvenirs. Popular cafes like Leopold Café and Café Mondegar add retro charm. Tourists enjoy bargaining and street-side snacks while exploring the bustling lane. It’s the perfect spot for shopping and soaking in local culture. Colaba Causeway is Mumbai’s colorful shopping trail."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests featuring lush greenery, wildlife safaris, and ancient Kanheri Caves. Visitors enjoy trekking, cycling, and toy train rides through nature. Leopards, deer, and exotic birds are seen occasionally. It offers peaceful relief from city chaos. SGNP is Mumbai’s wild corner of nature and history."
  }
],


 "services": [
  {
    "name": "Monthly Car and Driver Rentals in Mumbai",
    "description": "Our Monthly Car and Driver Rentals in Mumbai offer flexible and reliable transportation solutions for long-term needs. Perfect for corporate clients and individuals, this service ensures well-maintained vehicles driven by professional chauffeurs, providing comfort, safety, and punctuality throughout the rental period."
  },
  {
    "name": "Mumbai Monthly Car Hire with Driver",
    "description": "Mumbai Monthly Car Hire with Driver provides seamless monthly rental options with experienced drivers. Whether for daily commutes or business travel, enjoy reliable vehicles and professional service tailored to your schedule."
  },
  {
    "name": "Chauffeur Driven Monthly Car Mumbai",
    "description": "Chauffeur Driven Monthly Car Mumbai offers dedicated chauffeur-driven vehicles for long-term rentals. Experience stress-free transportation with courteous and professional drivers ensuring timely pickups and drop-offs."
  },
  {
    "name": "Corporate Monthly Car Rental Mumbai",
    "description": "Corporate Monthly Car Rental Mumbai specializes in customized leasing plans for businesses, streamlining employee transport and executive travel with flexible monthly packages including professional chauffeurs and transparent billing."
  },
  {
    "name": "Long-Term Car with Driver Mumbai",
    "description": "Long-Term Car with Driver Mumbai caters to clients needing vehicles for extended durations, combining affordability with premium service. Choose from sedans, SUVs, and more, all maintained for maximum comfort and safety."
  },
  {
    "name": "Affordable Monthly Driver Rentals Mumbai",
    "description": "Affordable Monthly Driver Rentals Mumbai delivers budget-friendly long-term vehicle hire solutions with skilled drivers. Ideal for startups and SMEs, this service ensures reliable transportation without compromising on quality."
  },
  {
    "name": "Sedan Monthly Driver Rental Mumbai",
    "description": "Sedan Monthly Driver Rental Mumbai offers premium sedans with experienced drivers on a monthly basis. Perfect for business professionals and small groups seeking comfortable and efficient travel."
  },
  {
    "name": "SUV Monthly Driver Hire Mumbai",
    "description": "SUV Monthly Driver Hire Mumbai provides spacious SUVs with chauffeurs for monthly rentals. Suitable for larger groups and families, this service combines luxury, space, and safety."
  },
  {
    "name": "Best Monthly Car Rental Mumbai",
    "description": "Best Monthly Car Rental Mumbai ensures top-quality vehicles and reliable chauffeurs for consistent monthly transportation. Enjoy personalized service, on-time pickups, and well-maintained cars for a hassle-free experience."
  },
  {
    "name": "Monthly Chauffeur Service Mumbai",
    "description": "Monthly Chauffeur Service Mumbai offers professional drivers for extended rentals, ensuring courteous, punctual, and discreet service for executives and regular travelers."
  },
  {
    "name": "Car with Driver Subscription Mumbai",
    "description": "Car with Driver Subscription Mumbai provides flexible subscription-based car rentals including chauffeurs, offering the convenience of monthly vehicle use without ownership hassles."
  },
  {
    "name": "Online Monthly Car with Driver Mumbai",
    "description": "Online Monthly Car with Driver Mumbai lets you book and manage your monthly car rentals with drivers easily via a convenient digital platform. Schedule rides, track usage, and access support effortlessly."
  },
  {
    "name": "One Month Car & Driver Mumbai",
    "description": "One Month Car & Driver Mumbai offers straightforward monthly car and driver rentals, ideal for those needing dependable transport for 30 days with flexible terms and excellent service."
  },
  {
    "name": "Corporate Vehicle Rental Mumbai",
    "description": "Corporate Vehicle Rental Mumbai provides long-term vehicle leasing solutions for businesses with professional chauffeurs, flexible plans, and priority support to meet all corporate travel needs."
  },
  {
    "name": "Monthly Vehicle Hire with Driver Mumbai",
    "description": "Monthly Vehicle Hire with Driver Mumbai delivers comprehensive monthly rental plans featuring a wide range of vehicles and experienced drivers to ensure safety, comfort, and reliability."
  }
],
"tableData": [
  ["Monthly Car and Driver Rentals in Mumbai", "Mumbai Monthly Car Hire with Driver"],
  ["Chauffeur Driven Monthly Car Mumbai", "Corporate Monthly Car Rental Mumbai"],
  ["Long-Term Car with Driver Mumbai", "Affordable Monthly Driver Rentals Mumbai"],
  ["Sedan Monthly Driver Rental Mumbai", "SUV Monthly Driver Hire Mumbai"],
  ["Best Monthly Car Rental Mumbai", "Monthly Chauffeur Service Mumbai"],
  ["Car with Driver Subscription Mumbai", "Online Monthly Car with Driver Mumbai"],
  ["One Month Car & Driver Mumbai", "Corporate Vehicle Rental Mumbai"],
  ["Monthly Vehicle Hire with Driver Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Monthly Car and Driver Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers flexible and affordable monthly car rentals with professional drivers across Mumbai."
  },
  {
    "WhyChooseheading": "Punctual and Convenient Daily Pickup",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups and smooth rides for your regular commuting needs."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel safely in sanitized, air-conditioned cars maintained to the highest standards."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Roads",
    "WhyChoosedescription": "Our drivers know the city’s routes well to provide efficient and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Monthly Rental Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden charges, covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, changes, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Needs",
    "WhyChoosedescription": "Choose from various plans designed to suit your monthly commuting or travel requirements."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Preferences",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and luggage."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly car and driver rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly car and driver rental services across Mumbai.',
  },
  {
    question: 'How can I book monthly car and driver rentals in Mumbai?',
    answer: 'You can book monthly rentals through our website, mobile app, or by contacting our dedicated customer support team.',
  },
  {
    question: 'What types of cars are available for monthly rentals with drivers in Mumbai?',
    answer: 'We offer a variety of cars including hatchbacks, sedans, SUVs, and luxury vehicles for monthly rentals.',
  },
  {
    question: 'Are the drivers experienced and knowledgeable about Mumbai routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-versed with Mumbai’s traffic and routes to ensure a smooth ride.',
  },
  {
    question: 'Can monthly rentals be customized to suit specific business or personal needs?',
    answer: 'Yes, we provide customized monthly rental plans tailored to your individual or corporate travel requirements.',
  },
  {
    question: 'Is monthly car and driver rental service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock monthly rental services with drivers in Mumbai.',
  },
  {
    question: 'What safety and hygiene protocols are followed for monthly rentals in Mumbai?',
    answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene standards to ensure passenger safety.',
  },
  {
    question: 'Can I change pickup and drop-off locations during the rental period?',
    answer: 'Yes, pickup and drop-off locations can be adjusted as per your travel needs throughout the rental duration.',
  },
  {
    question: 'What payment options are available for monthly car and driver rentals in Mumbai?',
    answer: 'We accept cash, cards, UPI, and digital wallets for easy and convenient payment.',
  },
  {
    question: 'Can I pre-book monthly car and driver rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels allows advance bookings to ensure vehicle availability for your monthly rental requirements.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Shah',
    feedback: 'Aaryan Travels made monthly car and driver rentals in Mumbai smooth and reliable. The service is outstanding!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Kapoor',
    feedback: 'Excellent cars and professional drivers. Monthly rentals in Mumbai through Aaryan Travels are highly recommended.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Car and Driver Rentals in Mumbai",
  "image": "https://aaryantravels.com/assets/images/monthly-car-and-driver-rentals-in-mumbai.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers flexible and affordable monthly car and driver rentals in Mumbai. Choose from sedans, SUVs, and luxury vehicles with professional chauffeurs for corporate or personal use.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating
    "ratingCount": "3500", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "28000",  // example monthly package
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/monthly-car-and-driver-rentals-in-mumbai"
  }
};






  return (
    <div>

<Helmet>
  <title>Monthly Car and Driver Rentals in Mumbai | Affordable Chauffeur Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Aaryan Travels offers flexible and affordable monthly car and driver rentals in Mumbai. Hire sedans, SUVs, or luxury cars with professional chauffeurs for corporate or personal travel."
  />
  <meta
    name="keywords"
    content="Monthly Car and Driver Rentals in Mumbai, Mumbai Monthly Car Hire with Driver, Chauffeur Driven Monthly Car Mumbai, Corporate Monthly Car Rental Mumbai, Long-Term Car with Driver Mumbai, Affordable Monthly Driver Rentals Mumbai, Sedan Monthly Driver Rental Mumbai, SUV Monthly Driver Hire Mumbai, Best Monthly Car Rental Mumbai, Monthly Chauffeur Service Mumbai, Car with Driver Subscription Mumbai, Online Monthly Car with Driver Mumbai, One Month Car & Driver Mumbai, Corporate Vehicle Rental Mumbai, Monthly Vehicle Hire with Driver Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycaranddriverrental;